<mat-form-field class="menu-select">
    <mat-select
        panelClass="custom-option-panel mt-2 min-w-[70px] menu-select-option-panel"
        [(value)]="currentOption"
        [compareWith]="compareOptions"
        [disableOptionCentering]="true"
        [hideSingleSelectionIndicator]="true"
        (selectionChange)="change($event)">
        <mat-select-trigger>
            {{ displaySelectedOption | applyPure: currentOption }}
        </mat-select-trigger>
        @for (option of options; track option) {
            <mat-option class="remove-check mb-[1px] uppercase" [value]="option.value">
                {{ option.viewValue }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
